import _Nielsen from "./nielsen";

customElements.define('rai-nielsen', _Nielsen);